import React, { useState, useEffect, useCallback } from "react";
import { Box, Chip, Alert } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CompAppUserList from "./CompAppUserList";
import AlertLogList from "../AlertLogList";

export default function CompanionAppTab({ vehicleData, isLoading }) {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Alert Logs" />
          <Tab label="App Users" />
        </Tabs>
      </Box>
      {value === 1 ? (
        <CompAppUserList vehicleData={vehicleData} />
      ) : (
        <AlertLogList vehicleData={vehicleData} />
      )}
    </>
  );
}
